import React, { forwardRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const Tween = forwardRef(function Tween(props, ref) {
    let { iconLabel, className, type, icon, singleLine, divider, style } = props;
    let divClass = null;
    switch (divider) {
        case "top":
            divClass = "trpr__div-top";
            break;
        case "bottom":
            divClass = "trpr__div-bottom";
            break;
        case "both":
            divClass = "trpr__div-both";
            break;
        default:
        // none
    }

    const iconEl = icon.includes("https://") ? (
        <object type="image/svg+xml" data={icon}>
            {iconLabel}
        </object>
    ) : (
        <i className={`trpr__icon-${icon}`} />
    );

    const classes = classNames(
        className,
        type ? "trpr__tween-" + type : "trpr__tween-primary",
        singleLine ? "trpr__single-line" : null,
        divClass,
    );

    return (
        <div ref={ref} className={classes} style={style}>
            <div className="col_wrapper">
                {icon && <div className="col_a">{iconEl}</div>}
                <div className="col_b" style={{ whiteSpace: "normal" }}>
                    <span>{props.children}</span>
                </div>
            </div>
        </div>
    );
});

Tween.propTypes = {
    iconLabel: PropTypes.string,
    icon: PropTypes.string.isRequired,
};

Tween.defaultProps = {
    icon: "menu",
    iconLabel: "",
};

Tween.displayName = "Tween";

export default Tween;
